import React from "react";
import StyledButton from "../buttons";
import { 
  BUTTONS_TYPE,
  ACTIVE_STATUS,
  INACTIVE_STATUS,
} from "Constants";
import { useTranslation } from "localization/translation";

export const BranchDetailsButtons = ({
  actionHandler,
  editPlanHandler,
  branch,
}) => {
  const translation = useTranslation();
  
  return (
    <>
      <div className="activate_field">
        <StyledButton
          name={
            !!branch?.status ? translation.deactivate : translation.activate
          }
          className={!!branch?.status ? INACTIVE_STATUS : ACTIVE_STATUS}
          onClick={() => actionHandler(branch?.status, branch?.id)}
        />
      </div>
      <div className="activate_field">
        <StyledButton
          className={BUTTONS_TYPE.edit}
          name={translation.edit_plan}
          onClick={() => editPlanHandler(branch?.id)}
        />
      </div>
    </>
  );
};
